/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'museum': {
    width: 110,
    height: 110,
    viewBox: '0 0 110 110',
    data: '<path pid="0" d="M110 100.361v6.885a2.75 2.75 0 01-2.75 2.754H2.75A2.75 2.75 0 010 107.246v-6.885a2.75 2.75 0 012.75-2.754h104.5a2.75 2.75 0 012.75 2.754zm0-79.294v10.441a2.75 2.75 0 01-2.75 2.754H99v50.951h5.5a2.75 2.75 0 012.75 2.754v4.131a2.75 2.75 0 01-2.75 2.755h-99a2.75 2.75 0 01-2.75-2.755v-4.13a2.75 2.75 0 012.75-2.755H11v-50.95H2.75A2.75 2.75 0 010 31.507v-10.44c0-1.173.736-2.211 1.842-2.599L54.092.153a2.764 2.764 0 011.816 0l52.25 18.316A2.752 2.752 0 01110 21.067zM60.5 85.213h8.25v-50.95H60.5v50.95zm-11-50.95h-8.25v50.95h8.25v-50.95zM22 85.212h8.25v-50.95H22v50.95zm66-50.95h-8.25v50.95H88v-50.95z" _fill="#2B363B"/>'
  }
})
